<script setup lang="ts">
defineProps<{
    error: string;
}>();
</script>

<template>
    <div class="p-4 border border-red rounded-lg bg-dark-mode-red mb-4">
        <p class="font-regular flex items-center">
            <i class="material-symbols-outlined text-xl mr-2">error</i>
            <span>{{ error }}</span>
        </p>
    </div>
</template>
